import { render, staticRenderFns } from "./collection-dialog.vue?vue&type=template&id=3433793e&scoped=true&"
import script from "./collection-dialog.vue?vue&type=script&lang=js&"
export * from "./collection-dialog.vue?vue&type=script&lang=js&"
import style0 from "./collection-dialog.vue?vue&type=style&index=0&id=3433793e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3433793e",
  null
  
)

export default component.exports